// extracted by mini-css-extract-plugin
export default {"root":"style_root__rEIrV","empty":"style_empty__F9ecK","sessionsList":"style_sessionsList__0AGsE"};